// DS: i1.16 Gems
import React from 'react';
import IconWrap, { Props } from '../IconWrap';

const Gems: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M22.95 2.667 28 17.49l-11.62-.705z" fill="#35A08F" />
      <path d="M28 17.49 17.694 29.333 16.38 16.784z" fill="#44CBAE" />
      <path d="m16.38 16.784 1.314 12.55L4 19.607z" fill="#2CBE7D" />
      <path d="M4 19.608 5.452 7.294l10.928 9.49z" fill="#A9F9E2" />
      <path d="m5.452 7.294 17.499-4.627-6.57 14.118z" fill="#2EE8D8" />
    </svg>
  </IconWrap>
);
Gems.displayName = 'Gems';

export default Gems;
